import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useGet } from "../../lib/hooks";
import { fmtDate } from "../../lib/api";
import { Pill } from "../Common";

const TONE = { ok: "green", failed: "red", skipped: "slate", waiting: "amber", cancelled: "slate" };

export function RunSteps({ steps }) {
  return (steps || []).map((s) => (
    <div key={s.step} className="flex items-start gap-3 border-t py-2 text-sm" data-testid={`wf-run-step-${s.step}`}>
      <span className="w-6 text-xs text-muted-foreground">{s.step}</span>
      <span className="flex-1"><span className="block">{s.name}</span><span className="block text-xs text-muted-foreground">{s.detail}</span></span>
      <Pill tone={TONE[s.status]}>{s.status}</Pill>
    </div>
  ));
}

function Run({ r }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-md border bg-card" data-testid={`wf-run-${r.id}`}>
      <button onClick={() => setOpen(!open)} className="flex w-full items-center gap-3 px-4 py-3 text-left">
        <span className="flex-1"><span className="block text-sm">{fmtDate(r.created_at)} · {r.trigger?.replace(/_/g, " ")}</span>
          <span className="block text-xs text-muted-foreground">{r.contact || "No contact"} · {(r.steps || r.log || []).length} steps</span></span>
        {r.live_test ? <Pill tone="amber">real test</Pill> : r.test && <Pill tone="blue">preview</Pill>}
        <Pill tone={TONE[r.status] || "slate"}>{r.status || "ok"}</Pill>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-4 pb-3">{r.steps ? <RunSteps steps={r.steps} /> : r.log.map((l, i) => <div key={i} className="border-t py-2 text-xs">{l}</div>)}</div>}
    </div>
  );
}

export function RunLogs({ wid }) {
  const [runs] = useGet(`/workflows/${wid}/runs`);
  if (!runs) return null;
  return (
    <div className="space-y-2" data-testid="wf-logs">
      {runs.map((r) => <Run key={r.id} r={r} />)}
      {!runs.length && <div className="rounded-md border p-8 text-center text-sm text-muted-foreground">No runs yet. Use Preview workflow, or publish it and wait for the trigger.</div>}
    </div>
  );
}
